import { QueryBuilderAstNodeType } from '../../../../types';

export const areAstsEqual = (
  a: QueryBuilderAstNodeType,
  b: QueryBuilderAstNodeType
): boolean => {
  if (a.type !== b.type) return false;

  if (a.type === 'condition' && b.type === 'condition') {
    return a.entityKey === b.entityKey && a.value === b.value;
  }

  if (a.type === 'group' && b.type === 'group') {
    if (a.operator !== b.operator) return false;
    if (a.children.length !== b.children.length) return false;

    return a.children.every((child, index) =>
      areAstsEqual(child, b.children[index])
    );
  }

  return false;
};
